import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import Button from 'components/common/Button/Button'

const ExpanderGroup = ({
  buttonActive,
  children = [],
  expanderHandler,
  menu,
  position,
  expanded,
  className
}) => {
  const expanderContent = React.Children.map(children, child =>
    child &&
    React.cloneElement(child, { changeActiveTab: index => expanderHandler(index) }))
  return <ExpanderWrapper className={ className }>
    {
      menu.map(({ title }, index) =>
        <ButtonWrapper
          data-at-expander-wrapper
          buttonIndex={ index }
          key={ index }
          onClick={ () => expanderHandler(index, children) }>
          <Title>
            <ExpanderButton data-at-expander-link bolder link >
              <Icon
                data-icon
                asset="plus-blue"
                alternative="minus-blue"
                condition={ buttonActive[index] }
                margin="0px 7px 0px 0px"
                float="none"
                alt="" />
              {title}
            </ExpanderButton>
          </Title>
        </ButtonWrapper>
      )
    }
    <div hidden={ !expanded }>
      {
        expanderContent &&
        React.Children.toArray(expanderContent)[position]
      }
    </div>
  </ExpanderWrapper>
}
ExpanderGroup.propTypes = {
  buttonActive: PropTypes.arrayOf(PropTypes.bool),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  expanded: PropTypes.bool,
  expanderHandler: PropTypes.func,
  menu: PropTypes.arrayOf(PropTypes.shape()),
  position: PropTypes.number
}
export default ExpanderGroup
const ButtonWrapper = styled.div`
  display: inline-block;
  margin-right: 10px;
  padding-left: ${props => props.buttonIndex !== 0 ? '10px' : '0'};
  border-left: ${props => props.buttonIndex !== 0 ? `1px solid ${Theme.colors.light_grey}` : '0'};
`
const ExpanderWrapper = styled.div`
  margin-bottom: 10px;
`

const Title = styled.span`
  font-weight: 700;
  line-height: 22px;
  padding: 5px 0;
`

const ExpanderButton = styled(Button)`
  && {
    padding: 0;
    line-height: 22px;
  }
`
